export default {
  port: process.env.REACT_APP_PORT,
  graphqlUri: process.env.REACT_APP_GRAPHQL_URI,
  admin: process.env.REACT_APP_ADMIN,
  restApi: process.env.REACT_APP_REST_API,
};
